import { Injectable } from '@angular/core';
import { PatientDataProvider } from '../patient-data/patient-data';
import {HistoryData} from '../../interfaces/history-data';
import {AlertData} from '../../interfaces/alert-data';

/*
  Generated class for the HistoryProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class HistoryProvider {

  constructor(private patientDataProvider: PatientDataProvider) {

  }

  setHistoryData(historyData: HistoryData): Promise<any> {
    return new Promise<void>((resolve) => {
      this.patientDataProvider.activePatientData.history.push(historyData);

      this.patientDataProvider.update(this.patientDataProvider.activePatientData).subscribe({next:(updateResponse: any) => {
        this.patientDataProvider.activePatientData._rev = updateResponse.data.data.data.rev;
        resolve();
      }, error:() => {
        resolve();
      }});
    });


  }

  openNewCase(_alertData: AlertData, desc, code): Promise<any> {
    return this.setHistoryData({
      dateTime: _alertData.dateTime,
      code,
      desc,
      editorPerson: _alertData.editorPerson
    });
  }

}
